const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const login = async (username, password, loginType, recaptchaToken) => {
  try {
    const response = await fetch(BACKEND_URL +
      `/api/v2/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        username,
        password,
        "type": loginType,
        "g_recaptcha_response": recaptchaToken,
      }),
    });
    const actualData = await response.json();
    if (!response.ok) {
      const err = new Error(actualData.errorMessage || "Identifiant ou mot de passe incorrect");
      err.status = response.status;
      err.captcha_required = actualData.captcha_required;
      throw err;
    }
    return actualData;
  } catch (err) {
    throw err;
  }
};

const logout = async () => {
  try {
    const response = await fetch(BACKEND_URL +
      `/api/v2/auth/logout`, {
      method: "POST",
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`Erreur de déconnexion!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const me = async () => {
  try {
    const response = await fetch(BACKEND_URL +
      `/api/v2/auth/me`, {
      method: "GET",
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`Erreur de récupération du profile utilisateur connecté!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};


const getConfig = async () => {
  try {
    const response = await fetch(BACKEND_URL + `/api/v2/auth/config`, {
      method: "GET",
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`Erreur lors de la récupération de la configuration!`);
    }
    return await response.json();
  } catch (err) {
    throw err;
  }
};

const requestCode = async (email, recaptchaToken) => {
  try {
    const response = await fetch(BACKEND_URL + `/api/v2/auth/code/request`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        email,
        "g_recaptcha_response": recaptchaToken,
      }),
    });
    const actualData = await response.json();
    if (!response.ok) {
      const err = new Error(actualData.errorMessage || `Erreur d'envoi du code!`);
      err.status = response.status;
      err.captcha_required = actualData.captcha_required;
      throw err;
    }
    return actualData;
  } catch (err) {
    throw err;
  }
};

const loginWithCode = async (email, code, recaptchaToken) => {
  try {
    const response = await fetch(BACKEND_URL + `/api/v2/auth/code/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        email,
        code,
        "g_recaptcha_response": recaptchaToken,
      }),
    });
    const actualData = await response.json();
    if (!response.ok) {
      throw new Error(actualData.errorMessage || `Erreur d'authentification!`);
    }
    return actualData;
  } catch (err) {
    throw err;
  }
};

const oauthMockLogin = async (email) => {
  try {
    const response = await fetch(BACKEND_URL + `/api/v2/auth/oauth/mock-login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ email }),
    });
    const actualData = await response.json();
    if (!response.ok) {
      throw new Error(actualData.errorMessage || `Erreur de connexion mock!`);
    }
    return actualData;
  } catch (err) {
    throw err;
  }
};

const authAPI = {
  login,
  me,
  logout,
  getConfig,
  requestCode,
  loginWithCode,
  oauthMockLogin,
};

export default authAPI;
